// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestedContentSidebar-cls1_CCF","cls2":"SuggestedContentSidebar-cls2_KiB SuggestedContentSidebar-cls1_CCF"};